import { getInitialState } from './actions';
import { ActionType, PickLocalState } from './model';

export const initialState: PickLocalState = getInitialState();

function logger(type, value = '') {
  console.info(
    `%cDispatcher: ${type} ${value ? `- ${value}` : ''}`,
    'color: #bada55;',
  );
}

function reducer(state: PickLocalState, action: ActionType): PickLocalState {
  switch (action.type) {
    case 'SET_EXPERIENCE_FILTER_INITIALS':
      logger(action.type);
      return { ...state, ...action.payload };
    case 'SET_NUMBER_OF_GUESTS':
      logger(
        action.type,
        `${action.payload?.nrOfAdults} adults, ${action.payload?.nrOfChildren} children`,
      );
      return { ...state, ...action.payload };
    case 'SET_SELECTED_DATE':
      logger(action.type, action.payload?.selectedDate);
      return { ...state, ...action.payload };
    case 'SET_SELECTED_TIME':
      logger(action.type, action.payload?.selectedTime);
      return { ...state, ...action.payload };
    case 'SET_SELECTED_HOST':
      logger(action.type, action.payload?.selectedHost?.id);
      return { ...state, ...action.payload };
  }
}

export default reducer;
